import { EmployeeId, GroupTeacherDTO, SelectOptionType } from '../../../types';
import { getFullName } from '../../getFullName';

export const parseJournalTeacherIntoSelectOptionType: (
    journalTeacher: GroupTeacherDTO,
) => SelectOptionType<EmployeeId> = (journalTeacher) => ({
    value: journalTeacher.id,
    label: getFullName(journalTeacher.firstName, journalTeacher.lastName),
});
